import { handleActions } from 'redux-actions';
import {
  key,
  setListLimit,
  applyFilter
} from './actions';
import settings from 'Root/settings.json';

export const selectors = {
  filter: state => state[key].filter,
  listLimit: state => state[key].listLimit,
};

export const timeout = settings.auto_logout;

const initialState = {
  listLimit: 0,
  filter: {
    id: {}
  }
};

export default handleActions({
  [applyFilter]: (state, action) => ({
    ...state,
    filter: action.payload.filter,
  }),
  [setListLimit]: (state, action) => ({
    ...state,
    listLimit: action.payload.limit
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/util/redux/patientList/reducer.js